import { ThumbsDown, ThumbsUp, Star } from "lucide-react";
import { cn } from "@/lib/utils";

function ActionButton({ onClick, label, className, children, disabled }) {
  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      onClick={onClick}
      disabled={disabled}
      className={cn(
        // pointer-events-auto so the buttons still work when the row floats
        // over the card inside a pointer-events-none wrapper (the full-bleed
        // mobile layout): buttons capture taps, the card stays draggable.
        "pointer-events-auto flex items-center justify-center rounded-full bg-white shadow-lg ring-1 ring-slate-200 transition",
        "hover:scale-110 hover:shadow-xl active:scale-95 disabled:pointer-events-none disabled:opacity-40",
        className
      )}
    >
      {children}
    </button>
  );
}

// Order: thumbs down (big, ink), star (small, super-like blue), thumbs up (big, lime).
export default function RenterActions({ onPass, onLike, onSuperLike, disabled }) {
  return (
    <div className="flex items-center justify-center gap-5">
      <ActionButton
        label="Pass"
        onClick={onPass}
        disabled={disabled}
        className="h-14 w-14 text-pass shadow-[0_8px_20px_rgba(30,42,56,0.14)]"
      >
        <ThumbsDown className="h-7 w-7" strokeWidth={2.4} />
      </ActionButton>

      <ActionButton
        label="Super like"
        onClick={onSuperLike}
        disabled={disabled}
        className="h-12 w-12 text-superlike shadow-[0_6px_16px_rgba(30,42,56,0.12)]"
      >
        <Star className="h-6 w-6 fill-superlike text-superlike" />
      </ActionButton>

      <ActionButton
        label="Like"
        onClick={onLike}
        disabled={disabled}
        className="h-14 w-14 text-like shadow-[0_8px_20px_rgba(30,42,56,0.14)]"
      >
        <ThumbsUp className="h-7 w-7" strokeWidth={2.4} />
      </ActionButton>
    </div>
  );
}
